let baseUrl = process.env.API_BASEURL;
let uploadImg = process.env.UPLOADER_URL;

//获取hash
const hashApi = baseUrl + '/index/getHash';
//数据看板
const dashboardApi = uploadImg + 'home/screen';

//三个看板切换
export const getScreenShowApi = uploadImg + 'Screen/getScreenShow'

//教师看板
export const teacherBoardApi = uploadImg + 'TeacherBoard/screen';

//学生看板
//年龄人数占比
export const ageProportionApi = uploadImg + 'StudentBoard/ageProportion';
//学生分析
export const studentAnalysisApi = uploadImg + 'StudentBoard/studentAnalysis';
//优秀学生列表
export const getExcellentStudentListApi = uploadImg + 'StudentBoard/getExcellentStudentList';
//学生指标
export const getStudentQuotaApi = uploadImg + 'StudentBoard/getStudentQuota';
//家长填报趋势
export const reportTrendsApi = uploadImg + 'StudentBoard/reportTrends';
//积分排名
export const scoreRankingApi = uploadImg + 'StudentBoard/scoreRanking';
//积分趋势
export const scoreTrendApi = uploadImg + 'StudentBoard/scoreTrend';
//年级指标排名-智育
export const gradeQuotaRankingApi = uploadImg + 'StudentBoard/gradeQuotaRanking';
//年级指标排名-德育
export const getGradeQuotaRankingApi = uploadImg + 'StudentBoard/getGradeQuotaRanking';

//获取首页数据
const homeListApi = baseUrl + '/Home/index';
// //获取首页查看数据
const homeInfoApi = baseUrl + '/Home/getInfo';
// 中小学登录
const loginApi = baseUrl + '/Login/index';
// 登出
const logOutApi = baseUrl + '/index/logout';
// 名师名校跳转登录
const msmxSsoUrlApi = baseUrl + '/index/getMsmxSsoUrl';

//修改密码
const modifyPasswordApi = baseUrl + '/Index/modifyPassword';
// 忘记密码
const resetPassword = baseUrl + '/login/resetPassword';
// 验证码
const codeApi = baseUrl + '/Captcha';
// 登录日志
const loginLogList = baseUrl + '/system.LoginLog/getList';
// 登录日志
const operateLogList = baseUrl + '/system.OperateLog/getList';
// 登录日志资源
const resArrayList = baseUrl + '/system.OperateLog/resArray';
// 登录日志(新)
const operateLogsList = baseUrl + '/system.OperateCruxLog/getList';
// 登录日志资源
const resArraysList = baseUrl + '/system.OperateCruxLog/resView';

//大数据对比接口
const dataListApi = baseUrl + '/basic.CheckInfo/getData';

// 图片上传
const uploadApi = baseUrl + '/index/uploads';

// 图片上传 无需token
const uploadApis = uploadImg + '/index/upload';

// 文件上传  <50M
const uploadFile = baseUrl + '/index/upfiles';

// 文件上传 <500M
export const uploadApiFile = uploadImg + 'api-upload';

// 文件上传  >500M
const uploadLargeFile = uploadImg + 'public-upload';

//资源列表
const nodesApi = baseUrl + '/Index/info';

// 区县列表
const regionApi = baseUrl + '/basic.PoliceStation/getSelectList';

// 学校列表
const basicSchoolApi = baseUrl + '/basic.School/getSchoolList';

//系统管理员列表
const adminListApi = baseUrl + '/account.System/getlist';

//系统管理员资源
const adminViewApi = baseUrl + '/account.System/resView';

//系统管理员信息
const adminInfoApi = baseUrl + '/account.System/getInfo';

//系统管理员添加
const adminAddApi = baseUrl + '/account.System/actAdd';

//系统管理员编辑
const adminEditApi = baseUrl + '/account.System/actEdit';

//系统管理员删除
const adminDelApi = baseUrl + '/account.System/actDelete';

// 管理员列表
const platManageListApi = baseUrl + '/account.PlatformManage/getList';

// 管理员增加
const platManageAddApi = baseUrl + '/account.PlatformManage/actAdd';

// 管理员编辑
const platManageEditApi = baseUrl + '/account.PlatformManage/actEdit';

// 管理员删除
const platManageDeleteApi = baseUrl + '/account.PlatformManage/actDelete';

// 管理员详情
const platManageInfoApi = baseUrl + '/account.PlatformManage/getInfo';

// 管理员资源
const platManageViewApi = baseUrl + '/account.PlatformManage/resView';

// 管理员状态变更
const platManageSetApi = baseUrl + '/account.PlatformManage/setState';

// 市级账号列表
const cityManageListApi = baseUrl + '/account.CityManage/getlist';

// 市级账号增加
const cityManageAddApi = baseUrl + '/account.CityManage/actAdd';

// 市级账号编辑
const cityManageEditApi = baseUrl + '/account.CityManage/actEdit';

// 市级账号删除
const cityManageDeleteApi = baseUrl + '/account.CityManage/actDelete';

// 市级账号详情
const cityManageInfoApi = baseUrl + '/account.CityManage/getInfo';

// 市级账号资源
const cityManageViewApi = baseUrl + '/account.CityManage/resView';

// 市级账号状态变更
const cityManageSetApi = baseUrl + '/account.CityManage/setState';

// 区级账号列表
const areaManageListApi = baseUrl + '/account.AreaManage/getlist';

// 区级账号添加
const areaManageActAddApi = baseUrl + '/account.AreaManage/actAdd';

// 区级账号编辑
const areaManageActEditApi = baseUrl + '/account.AreaManage/actEdit';

// 区级账号删除
const areaManageActDelApi = baseUrl + '/account.AreaManage/actDelete';

// 区级资源列表
const areaManageViewApi = baseUrl + '/account.AreaManage/resView';

// 区级账号详情
const areaManageInfoApi = baseUrl + '/account.AreaManage/getInfo';

// 区级账号状态变更
const areaManageSetApi = baseUrl + '/account.AreaManage/setState';

// 学校账号列表
const schoolManageListApi = baseUrl + '/account.SchoolManage/getlist';

// 学校账号增加
const schoolManageAddApi = baseUrl + '/account.SchoolManage/actAdd';

// 学校账号编辑
const schoolManageEditApi = baseUrl + '/account.SchoolManage/actEdit';

// 学校账号删除
const schoolManageDeleteApi = baseUrl + '/account.SchoolManage/actDelete';

// 学校账号详情
const schoolManageInfoApi = baseUrl + '/account.SchoolManage/getInfo';

// 获取学校列表
const schoolManageQueryApi = baseUrl + '/account.SchoolManage/getSchool';

// 学校账号状态
const schoolManageSetApi = baseUrl + '/account.SchoolManage/setState';

// 学校账号资源
const schoolManageViewApi = baseUrl + '/account.SchoolManage/resView';

// 学校账号导入
const schoolManageImportApi = baseUrl + '/account.SchoolManage/importData';

// 学校账号导入错误
const schoolManageErrApi = baseUrl + '/account.SchoolManage/getImportError';

// 学校管理员账号列表
const schoolPlatManageListApi = baseUrl + '/account.SchoolPlatManage/getList';

// 学校管理员账号增加
const schoolPlatManageAddApi = baseUrl + '/account.SchoolPlatManage/actAdd';

// 学校管理员账号编辑
const schoolPlatManageEditApi = baseUrl + '/account.SchoolPlatManage/actEdit';

// 学校管理员账号删除
const schoolPlatManageDeleteApi = baseUrl + '/account.SchoolPlatManage/actDelete';

// 学校管理员账号详情
const schoolPlatManageInfoApi = baseUrl + '/account.SchoolPlatManage/getInfo';

// 学校管理员账号资源
const schoolPlatManageViewApi = baseUrl + '/account.SchoolPlatManage/resView';

// 学校管理员状态变更
const schoolPlatManageSetApi = baseUrl + '/account.SchoolPlatManage/setState';

// 学校管理员图片上传
const schoolUpdataApi = baseUrl + '/basic.schools/upload';

//学校管理列表
const schoolListApi = baseUrl + '/basic.schools/getList';

// 学校管理新增
const schoolAddApi = baseUrl + '/basic.schools/actAdd';

// 学校管理编辑
const schoolEditApi = baseUrl + '/basic.schools/actEdit';

// 学校管理详情
const schoolInfoApi = baseUrl + '/basic.schools/getInfo';

// 学校管理删除
const schoolDelApi = baseUrl + '/basic.schools/actDelete';
// 学校管理获取学校
const getSchoolApi = baseUrl + '/basic.schools/getSchool';
// 学校管理批量权限设置
const schoolNodeApi = baseUrl + '/basic.schools/batchSetNodes';
//  学校显示状态
const schoolDisplayApi = baseUrl + '/basic.schools/setDisplay';

// 学校市直状态
const schoolDirectlyApi = baseUrl + '/basic.schools/setDirectly';

// 学校排序更改
const schoolSortApi = baseUrl + '/basic.schools/setSort';

// 学校管理资源
const schoolViewApi = baseUrl + '/basic.schools/resView';

// 学校状态变更
const schoolSetApi = baseUrl + '/basic.schools/setState';


//学校信息详细信息
const schoolInfosApi = baseUrl + '/edu.school/getInfo';

//学校信息编辑
const schoolInfoActEdit = baseUrl + '/edu.school/actEdit';

//切换角色
const switchUserRolesApi = baseUrl + '/index/switchUserRoles';
//用户列表
const userListApi = baseUrl + '/basic.Users/getList';

//用户列表-区县
const regionListApi = baseUrl + '/basic.Users/getRegion';

//用户列表-更换手机号
const unbindUserApi = baseUrl + '/basic.Users/unbindUser';
//用户列表-资源
const userViewApi = baseUrl + '/basic.Users/resView';
//用户列表-删除
const userListDelApi = baseUrl + '/basic.Users/DeleteChild';

// 参数配置列表
const configurationManagementListApi = baseUrl + '/system.Config/getList';
// 参数配置新增
const configurationManagementAddApi = baseUrl + '/system.Config/actAdd';
// 参数配置编辑
const configurationManagementEditApi = baseUrl + '/system.Config/actEdit';
// 参数配置删除
const configurationManagementDelApi = baseUrl + '/system.Config/actDelete';
// 缓存管理列表
const cacheListApi = baseUrl + '/CacheData/getCache';
// 缓存管理-刷新单个缓存
const refreshCacheApi = baseUrl + '/CacheData/refreshCache';
// 缓存管理-刷新所有缓存
const refreshCacheQbApi = baseUrl + '/CacheData/updateCache';

// 系统设置-扩展模块 
// 列表
export const extendListApi = baseUrl + '/system.Module/getList'
// 详情
export const extendInfoApi = baseUrl + '/system.Module/getInfo'
// 新增
export const extendAddApi = baseUrl + '/system.Module/actAdd'
// 编辑
export const extendEditApi = baseUrl + '/system.Module/actEdit'
// 删除
export const extendDeleteApi = baseUrl + '/system.Module/actDelete'
// 更改状态
export const extendSetStateApi = baseUrl + '/system.Module/actSetState'

// 设备管理列表（系统）
// 列表
export const basicDeviceListApi = baseUrl + '/basic.Device/getList'
// 详情
export const basicDeviceInfoApi = baseUrl + '/basic.Device/getInfo'
// 资源
export const basicDeviceViewApi = baseUrl + '/basic.Device/resView'
// 新增
export const basicDeviceAddApi = baseUrl + '/basic.Device/actAdd'
// 编辑
export const basicDeviceEditApi = baseUrl + '/basic.Device/actEdit'
// 删除
export const basicDeviceDelApi = baseUrl + '/basic.Device/actDelete'
// 状态
export const basicDeviceDisabledApi = baseUrl + '/basic.Device/actDisabled'

//设备配置
//列表
export const basicDevicetConfigListApi = baseUrl + '/basic.device/getConfigList';
//设备配置信息保存
export const basicDevicetConfigSaveApi = baseUrl + '/basic.device/actConfigSave';
//设备的指派学校列表
export const basicDeviceSchoolListApi = baseUrl + '/basic.device/getSchoolList';
//设备指派学校信息保存
export const basicDeviceSchoolSaveApi = baseUrl + '/basic.device/actSchoolSave';


// 角色配置列表
const roleManagementListApi = baseUrl + '/system.Roles/getList';
// 角色配置新增
const roleManagementAddApi = baseUrl + '/system.Roles/actAdd';
// 角色配置编辑
const roleManagementEditApi = baseUrl + '/system.Roles/actEdit';
// 角色配置-选中的权限数组
const roleManagementRolesApi = baseUrl + '/system.Roles/getRoleListVue';
// 角色配置-删除
const roleManagementDelApi = baseUrl + '/system.Roles/actDelete';
// 角色配置-权限范围
const roleManagementRangeApi = baseUrl + '/system.Roles/getGradeList';
// 角色配置-权限范围列表
const roleManagementRangeListApi = baseUrl + '/system.Roles/getTypeListVue';
//权限
const roleManagementRangeActBatchNodes = baseUrl + '/system.Roles/actBatchNodes';

// 区域管理-列表
const regionalManagementListApi = baseUrl + '/system.Region/getList';
// 区域管理-新增
const regionalManagementAddApi = baseUrl + '/system.Region/actAdd';
// 区域管理-编辑
const regionalManagementEditApi = baseUrl + '/system.Region/actEdit';
// 区域管理-删除
const regionalManagementDelApi = baseUrl + '/system.Region/actDelete';

// 数据字典-列表
const dataDictionaryListApi = baseUrl + '/system.dictionary/getList';
// 数据字典-字典列表
const dataDictionaryZdListApi = baseUrl + '/system.dictionary/getLists';
// 数据字典-新增父级
const dataDictionaryZdAddApi = baseUrl + '/system.dictionary/actAdd';
// 数据字典-编辑
const dataDictionaryZdEditApi = baseUrl + '/system.dictionary/actEdit';
// 数据字典-删除
const dataDictionaryZdDelApi = baseUrl + '/system.dictionary/actDelete';
// 数据字典-删除
const dataDictionaryZdInfoApi = baseUrl + '/system.dictionary/getInfo';
// 批量比对
const batchComparisonApi = baseUrl + '/CheckHandle/ExecuteCheck';
// 批量处理
const batchProcessingApi = baseUrl + '/TaskHandle/ExecuteHandle';

// 资源管理列表
const resourceManagementListgApi = baseUrl + '/system.nodes/getList';
// 资源管理-新增父级
const resourceManagementAddApi = baseUrl + '/system.nodes/actAdd';
// 资源管理-编辑
const resourceManagementEditApi = baseUrl + '/system.nodes/actEdit';
// 资源管理-删除
const resourceManagementDelApi = baseUrl + '/system.nodes/actDelete';
// 资源管理-详情
const resourceManagementInfoApi = baseUrl + '/system.nodes/getInfo';

// 机构资源管理列表
const resourceOrgListgApi = baseUrl + '/system.OrgNodes/getList';
// 机构资源管理-新增父级
const resourceOrgAddApi = baseUrl + '/system.OrgNodes/actAdd';
// 机构资源管理-编辑
const resourceOrgEditApi = baseUrl + '/system.OrgNodes/actEdit';
// 机构资源管理-删除
const resourceOrgDelApi = baseUrl + '/system.OrgNodes/actDelete';


// 机构角色配置列表
const roleOrgListApi = baseUrl + '/system.OrgRoles/getList';
// 机构角色配置新增
const roleOrgAddApi = baseUrl + '/system.OrgRoles/actAdd';
// 机构角色配置编辑
const roleOrgEditApi = baseUrl + '/system.OrgRoles/actEdit';
// 机构角色配置-选中的权限数组
const roleOrgRolesApi = baseUrl + '/system.OrgRoles/getRoleLists';
// 机构角色配置-删除
const roleOrgDelApi = baseUrl + '/system.OrgRoles/actDelete';
// 机构角色配置-权限列表
const roleOrgRangeListApi = baseUrl + '/system.OrgRoles/getTypeLists';

//发送验证码
const getVerifyApi = baseUrl + '/login/getVerify';
//发送验证码
const regVerifyApi = baseUrl + '/login/regVerify';

//演练管理
//资源
const drillView = baseUrl + '/rehearsal.DrillManage/resView';
//列表
const drillListApi = baseUrl + '/rehearsal.DrillManage/getList';
//查看任务
const viewTaskApi = baseUrl + '/rehearsal.DrillManage/getTaskInfo';
//演练分配-删除
const viewTaskDelApi = baseUrl + '/rehearsal.DrillManage/actDelete';
//操作演练-开始/结束
const drillStaEnd = baseUrl + '/rehearsal.DrillManage/setState';
//演练分配-新增
const drillManagementAddApi = baseUrl + '/rehearsal.DrillManage/actAddTask';
//演练分配-编辑
//铃声配置
const ringtoneConfigurationApi = baseUrl + '/ringtoneConfiguration';
const drillManagementEditApi = baseUrl + '/rehearsal.DrillManage/actEditTask';
//铃声配置-列表
const ringtoneConfigurationGetApi = baseUrl + '/rehearsal.DrillManage/getRingtoneList';
//铃声配置-新增
const ringtoneConfigurationAddApi = baseUrl + '/rehearsal.DrillManage/actAddRingtone';
//铃声配置-详情
const ringtoneConfigurationGetInfoApi = baseUrl + '/rehearsal.DrillManage/getRingtoneInfo';
//铃声配置-编辑
const ringtoneConfigurationGetEdit = baseUrl + '/rehearsal.DrillManage/actEditRingtone';
//铃声配置-删除
const ringtoneConfigurationDel = baseUrl + '/rehearsal.DrillManage/actDeleteRingtone';
//电子班牌配置-列表
const deckListApi = baseUrl + '/rehearsal.DrillManage/getCardList';
//电子班牌配置-编辑
const deckArrangementEditApi = baseUrl + '/rehearsal.DrillManage/actEditCard';
//电子班牌配置-新增
const deckArrangementAdd = baseUrl + '/rehearsal.DrillManage/actAddCard';
//电子班牌配置-详情
const deckArrangementInfo = baseUrl + '/rehearsal.DrillManage/getCardInfo';
//电子班牌配置-详情
const deckArrangementDel = baseUrl + '/rehearsal.DrillManage/actDeleteCard';
//屏幕配置--列表
const screenConfigurationList = baseUrl + '/rehearsal.DrillManage/getScreenList';
//屏幕配置--详情
const screenConfigurationInfo = baseUrl + '/rehearsal.DrillManage/getScreenInfo';
//屏幕配置--新增
const screenConfigurationAdd = baseUrl + '/rehearsal.DrillManage/actAddScreen';
//屏幕配置--编辑
const screenConfigurationEdit = baseUrl + '/rehearsal.DrillManage/actEditScreen';
//屏幕配置--删除
const screenConfigurationDel = baseUrl + '/rehearsal.DrillManage/actDeleteScreen';
//预警灯配置--列表
const switchMentList = baseUrl + '/rehearsal.DrillManage/getLampList';
//预警灯配置--详情
const switchMentInfo = baseUrl + '/rehearsal.DrillManage/getLampInfo';
//预警灯配置--新增
const switchMentAdd = baseUrl + '/rehearsal.DrillManage/actAddLamp';
//预警灯配置--编辑
const switchMentEdit = baseUrl + '/rehearsal.DrillManage/actEditLamp';
//预警灯配置--删除
const switchMentDel = baseUrl + '/rehearsal.DrillManage/actDeleteLamp';

//多媒体管理
//列表
const multimediaList = baseUrl + '/multimedia.Screen/getList';
//资源
const multimediaView = baseUrl + '/multimedia.Screen/resView';
//详情
const multimediaInfo = baseUrl + '/multimedia.Screen/getInfo';
//新增
const multimediaAdd = baseUrl + '/multimedia.Screen/actAdd';
//编辑
const multimediaEdit = baseUrl + '/multimedia.Screen/actEdit';
//删除
const multimediaDel = baseUrl + '/multimedia.Screen/actDelete';
//停止播放
const multimediaStop = baseUrl + '/multimedia.Screen/setState';

//设备管理
//资源
const equipmentView = baseUrl + '/safe.device/resView';
//资源
const equipmentTypeList = baseUrl + '/safe.device/getTypeList';
//列表
const equipmentList = baseUrl + '/safe.device/index';
//详情
const equipmentInfo = baseUrl + '/safe.device/getInfo';
//新增
const equipmentAdd = baseUrl + '/safe.device/actAdd';
//编辑
const equipmentEdit = baseUrl + '/safe.device/actEdit';
//删除
const equipmentDel = baseUrl + '/safe.device/actDelete';
//状态
const equipmentDisabled = baseUrl + '/safe.device/actDisabled';
//品牌资源
const getBrandListApi = baseUrl + '/safe.device/getBrandList';
//型号资源
const getModelListApi = baseUrl + '/safe.device/getModelList';

//预警看板
//列表
const earlyWarningList = baseUrl + '/safetyforecast.warning/getList';
//详情
const earlyWarningInfo = baseUrl + '/safetyforecast.warning/getInfo';
//资源
const earlyWarningView = baseUrl + '/safetyforecast.warning/resView';

//预警处理
//列表
const warningProcessingList = baseUrl + '/classlog.SickWarning/getList';
//详情
const warningProcessingInfo = baseUrl + '/classlog.SickWarning/getInfo';
//处理
const warningProcessingHandle = baseUrl + '/classlog.SickWarning/actManage';
//删除
const warningProcessingDel = baseUrl + '/classlog.SickWarning/actDelete';

//素材中心
//列表
const materialCenterList = baseUrl + '/safe.FilesSource/getList';
//新增
const materialCenterAdd = baseUrl + '/safe.FilesSource/add';
//编辑
const materialCenterEdit = baseUrl + '/safe.FilesSource/edit';
//删除
const materialCenterDel = baseUrl + '/safe.FilesSource/del';

//设备位置管理
//列表
const locationManagementList = baseUrl + '/safe.position/getList';
//列表
const locationManagementView = baseUrl + '/safe.position/resView';
//详情
const locationManagementInfo = baseUrl + '/safe.position/getInfo';
//新增
const locationManagementAdd = baseUrl + '/safe.position/actAdd';
//编辑
const locationManagementEdit = baseUrl + '/safe.position/actEdit';
//删除
const locationManagementDel = baseUrl + '/safe.position/actDelete';

//数据看板
//日期
const dataBoardDate = baseUrl + '/safe.Home/index';
//预警相关
const dataBoardWarn = baseUrl + '/safe.Home/getWarnList';
//考勤情况
const dataBoardAttendance = baseUrl + '/safe.Home/getAttendanceList';
//来访、陪餐、打卡
const dataBoardVisit = baseUrl + '/safe.Home/getVisitList';
//天气接口-当天
const dataBoardWeather = 'http://www.weather.com.cn/data/cityinfo/101200201.html';

//预警相关
const dataBoardWarnTwo = uploadImg + 'Home/getWarnList';
//考勤情况
const dataBoardAttendanceTwo = uploadImg + 'Home/getAttendanceList';
//来访、陪餐、打卡
const dataBoardVisitTwo = uploadImg + 'Home/getVisitList';

//防疫
const newSubmitInfoApi = uploadImg + '/index/visitSave';

//临时铃声
//资源
const temporaryRingtoneView = baseUrl + '/ringing.RingtoneTemp/resView';
//列表
const temporaryRingtoneList = baseUrl + '/ringing.RingtoneTemp/getList';
//详情
const temporaryRingtoneInfo = baseUrl + '/ringing.RingtoneTemp/getInfo';
//添加
const temporaryRingtoneAdd = baseUrl + '/ringing.RingtoneTemp/actAdd';
//编辑
const temporaryRingtoneEdit = baseUrl + '/ringing.RingtoneTemp/actEdit';
//删除
const temporaryRingtoneDel = baseUrl + '/ringing.RingtoneTemp/actDelete';
//状态
const temporaryRingtoneStatus = baseUrl + '/ringing.RingtoneTemp/setState';
//铃声列表
const temporaryRingtoneFileList = baseUrl + '/ringing.RingtoneTemp/getFileList';

//演练结果
//列表
const drillResultList = baseUrl + '/rehearsal.DrillResult/getList';
//资源
const drillResultView = baseUrl + '/rehearsal.DrillResult/resView';
//演练详情
const drillResultInfo = baseUrl + '/rehearsal.DrillResult/getInfo';
//人员任务详情
const drillResultTaskInfo = baseUrl + '/rehearsal.DrillResult/getTaskInfo';

//设备开关
//列表
const equipmentSwitchList = baseUrl + '/switchgear.TaskOnoff/getList';
//资源
const equipmentSwitchView = baseUrl + '/switchgear.TaskOnoff/resView';
//新增
const equipmentSwitchAdd = baseUrl + '/switchgear.TaskOnoff/actAdd';
//编辑
const equipmentSwitchEdit = baseUrl + '/switchgear.TaskOnoff/actEdit';
//删除
const equipmentSwitchDel = baseUrl + '/switchgear.TaskOnoff/actDelete';
//详情
const equipmentSwitchInfo = baseUrl + '/switchgear.TaskOnoff/getInfo';
//设备详情
const equipmentSwitchDeviceInfo = baseUrl + '/switchgear.TaskOnoff/getDeviceInfo';
//编辑设备
const equipmentSwitchEditDevice = baseUrl + '/switchgear.TaskOnoff/actEditDevice';
//状态开关
const equipmentSwitchStatus = baseUrl + '/switchgear.TaskOnoff/setStatus';
//一键开启/关闭
const equipmentSwitchAllOnOff = baseUrl + '/switchgear.TaskOnoff/oneClickOnoff';
//设备列表
const equipmentSwitchTypeList = baseUrl + '/switchgear.TaskOnoff/getTypeList';

// 人员管理模块-
//学生管理
//列表
const studentManagementList = baseUrl + '/students.students/getList';
//年级列表
const studentManagementGrades = baseUrl + '/students.students/getGrades';
//班级列表
const studentManagementClass = baseUrl + '/students.students/getClass';
//详情
const studentManagementInfo = baseUrl + '/students.students/getInfo';
//新增
const studentManagementAdd = baseUrl + '/students.students/actAdd';
//编辑
const studentManagementEdit = baseUrl + '/students.students/actEdit';
//删除
const studentManagementDel = baseUrl + '/students.students/actDelete';
//导入
const studentManagementImport = baseUrl + '/students.students/import';
//导出
const studentManagementExport = baseUrl + '/students.students/export';
//导入结果
const studentManagementImportError = baseUrl + '/students.students/getImportError';
//获取性别
const studentManagementGetSex = baseUrl + '/students.students/getSex';

//学生在校表现
//列表
const schoolPerformanceList = baseUrl + '/erecord.StudentsConduct/getList';
//学生档案列表
const schoolPerformanceArchivesList = baseUrl + '/erecord.StudentsConduct/getArchivesList';
//学生档案详情
const schoolPerformanceInfo = baseUrl + '/erecord.StudentsConduct/getInfo';
//资源
const schoolPerformanceView = baseUrl + '/erecord.StudentsConduct/resView';
//新增
const schoolPerformanceAdd = baseUrl + '/erecord.StudentsConduct/actAdd';
//编辑
const schoolPerformanceEdit = baseUrl + '/erecord.StudentsConduct/actEdit';
//删除
const schoolPerformanceDel = baseUrl + '/erecord.StudentsConduct/actDelete';

//在线档案管理
//列表
const archivesManagementList = baseUrl + '/erecord.StudentsArchives/getList';
//学生档案列表
const archivesManagementArchivesList = baseUrl + '/erecord.StudentsArchives/getArchivesList';
//学生档案详细
const archivesManagementArchivesInfo = baseUrl + '/erecord.StudentsArchives/getArchivesInfo';
//基本信息
const archivesManagementArchivesBasicInfo = baseUrl + '/erecord.StudentsArchives/getBasicInfo';

//缴费管理（班主任）
//列表
const payManagementList = baseUrl + '/teacher.FeeSetting/getList';
//详情
const payManagementInfo = baseUrl + '/teacher.FeeSetting/getInfo';
//资源
const payManagementView = baseUrl + '/teacher.FeeSetting/resView';
//查看
const payManagementStudentList = baseUrl + '/teacher.FeeSetting/getStudentList';
//列表
const payManagementAdd = baseUrl + '/teacher.FeeSetting/actAdd';
//列表
const payManagementEdit = baseUrl + '/teacher.FeeSetting/actEdit';
//列表
const payManagementDel = baseUrl + '/teacher.FeeSetting/actDelete';

//缴费管理(领导)
//列表
const paymentSettingList = baseUrl + '/fund.Payment/getList';
//查看
const paymentSettingStudentList = baseUrl + '/fund.Payment/getStudentList';
//查看
const paymentSettingView = baseUrl + '/fund.Payment/resView';

//心理咨询管理领导
//资源
const mentalHealthViewApi = baseUrl + '/safe.MentalHealth/resView';
//列表
const mentalHealthListApi = baseUrl + '/safe.MentalHealth/index';
//详情
const mentalHealthInfoApi = baseUrl + '/safe.MentalHealth/getInfo';

//素质报告书（班主任）
//管理-列表
const reportManagementList = baseUrl + '/erecord.StudentsQuality/getList';
//新增-列表
const reportStudentList = baseUrl + '/erecord.StudentsQuality/getStudentList';
//资源
const reportAddView = baseUrl + '/erecord.StudentsQuality/resView';
//新增
const reportAdd = baseUrl + '/erecord.StudentsQuality/actAdd';
//详情
const reportAddInfo = baseUrl + '/erecord.StudentsQuality/getInfo';
//编辑
const reportEdit = baseUrl + '/erecord.StudentsQuality/actEdit';
//删除
const reportDelete = baseUrl + '/erecord.StudentsQuality/actDelete';

//素质报告书（领导）
const reportSettingList = baseUrl + '/erecord.StudentsReport/getList';
//详情
const reportSettingInfo = baseUrl + '/erecord.StudentsReport/getInfo';
//删除
const reportSettingDelete = baseUrl + '/erecord.StudentsReport/actDelete';

//心理咨询
//列表
const psychologicalList = baseUrl + '/safe.MentalHealth/index';
//资源接口
const psychologicalView = baseUrl + '/safe.MentalHealth/resView';
//列表
const psychologicalInfo = baseUrl + '/safe.MentalHealth/getInfo';
//列表
const psychologicalReply = baseUrl + '/safe.MentalHealth/reply';
//获取学生信息
const userInfoApi = uploadImg + 'Counseling/getStuInfo';
//心理咨询学生列表
const counselingListApi = uploadImg + 'Counseling/getList';
//录音开始时间
const recordStartTimeApi = uploadImg + 'Counseling/start';
//录音结束时间
const recordEndTimeApi = uploadImg + 'Counseling/end';
//上传文件
const uploadFileApi = uploadImg + 'index/upfile';
//超时处理
const counselingTimeOutApi = uploadImg + 'Counseling/timeout';
//电子学生证
const studentCardListApi = baseUrl + '/students.StudentsWarn/getList';
//电子学生证详情
const studentCardDetailApi = baseUrl + '/students.StudentsWarn/getInfo';
//电子学生证处置
const studentCardHandleApi = baseUrl + '/students.StudentsWarn/actManage';

//设备地图
//列表
const equipmentMapList = baseUrl + '/students.StudentsMap/getList';
//实时点位
const equipmentMapInfo = baseUrl + '/students.StudentsMap/getInfo';
//历史轨迹
const equipmentMapHistoryList = baseUrl + '/students.StudentsMap/getHistoryList';

//通知公告
//获取公告列表
const noticeListApi = baseUrl + '/notice.ClassNotice/getList';
//新增公告
const noticeAddApi = baseUrl + '/notice.ClassNotice/actAdd';
//编辑公告
const noticeEditApi = baseUrl + '/notice.ClassNotice/actEdit';
//获取公告详情
const noticeInfoApi = baseUrl + '/notice.ClassNotice/getInfo';
//发布公告
const noticePublishApi = baseUrl + '/notice.ClassNotice/actPublish';
//删除公告
const noticeDeleteApi = baseUrl + '/notice.ClassNotice/actDelete';
//获取公告列表
const noticeSchoolListApi = baseUrl + '/notice.Notice/getList';
//获取公告资源
const noticeSchoolViewApi = baseUrl + '/notice.Notice/resView';
//新增公告
const noticeSchoolAddApi = baseUrl + '/notice.Notice/actAdd';
//编辑公告
const noticeSchoolEditApi = baseUrl + '/notice.Notice/actEdit';
//获取公告详情
const noticeSchoolInfoApi = baseUrl + '/notice.Notice/getInfo';
//发布公告
const noticeSchoolPublishApi = baseUrl + '/notice.Notice/actPublish';
//删除公告
const noticeSchoolDeleteApi = baseUrl + '/notice.Notice/actDelete';
// 获取协议类型
const noticeProtocolApi = baseUrl + '/notice.Notice/getProtocol';
// 获取签字列表
const noticeSignListApi = baseUrl + '/notice.Notice/getSignList';
// 获取确认列表
const noticeConfirmListApi = baseUrl + '/notice.Notice/getConfirmList';
// 各班级签字情况
const noticeClassSignApi = baseUrl + '/notice.Notice/getClassSign';
// 各班级确认情况
const noticeClassConfirmApi = baseUrl + '/notice.Notice/getClassConfirm';
// 导出公告
const noticeExportApi = baseUrl + '/notice.Notice/export';

// 失物招领
// 失物招领列表
const lostListApi = baseUrl + '/school.Found/getList';
// 失物招领详情
const lostInfoApi = baseUrl + '/school.Found/getInfo';

// 班级课表
// 班级课表-班主任
// 课表列表
const timetableTListApi = baseUrl + '/timetable.TeacherTimetable/getList';
// 新增课表
const timetableTAddApi = baseUrl + '/timetable.TeacherTimetable/actAdd';
// 发布课表
const timetableTPublishApi = baseUrl + '/timetable.TeacherTimetable/actPublish';
// 获取课表详情
const timetableTInfoApi = baseUrl + '/timetable.TeacherTimetable/getInfo';
// 编辑课表
const timetableTEditApi = baseUrl + '/timetable.TeacherTimetable/actEdit';
// 删除课表
const timetableTDeleteApi = baseUrl + '/timetable.TeacherTimetable/actDelete';
// 获取课程列表
const timetableTViewApi = baseUrl + '/timetable.TeacherTimetable/resView';

// 班级课表-校领导
// 校领导-课表列表
const timetableSchoolListApi = baseUrl + '/timetable.SchoolTimetable/getList';
// 校领导-课表详情
const timetableSchoolInfoApi = baseUrl + '/timetable.SchoolTimetable/getInfo';
const timetableSchoolExportApi = baseUrl + '/timetable.SchoolTimetable/export';

// 考试成绩-旧
// 获取列表-班主任
const examlistApi = baseUrl + '/erecord.achievement/getList';
// 获取资源
const examViewApi = baseUrl + '/erecord.achievement/resView';
// 获取列表-领导
const examSchoolListApi = baseUrl + '/erecord.achievement/getAll';
// 新增班级成绩记录
const examAddApi = baseUrl + '/erecord.achievement/actAdd';
// 获取班级学生列表
const examStudentsApi = baseUrl + '/erecord.achievement/getStudents';
// 发布
const examStateApi = baseUrl + '/erecord.achievement/setState';
// 查看详情
const examInfoApi = baseUrl + '/erecord.achievement/getInfo';
// 删除
const examDeleteApi = baseUrl + '/erecord.achievement/actDelete';
// 新增学生成绩
const examActAddStuApi = baseUrl + '/erecord.achievement/actAddStu';
//班牌版本管理
export const classCardVersionListApi = baseUrl + '/system.Version/getList';
//详情
export const classCardVersionDetailApi = baseUrl + '/system.Version/getInfo';
//新增
export const classCardVersionAddApi = baseUrl + '/system.Version/actAdd';
//编辑
export const classCardVersionEditApi = baseUrl + '/system.Version/actEdit';

// 考试成绩-领导-新
// 列表
export const examManageListApi = baseUrl + '/erecord.ExamManage/getList';
// 资源
export const examManageViewApi = baseUrl + '/erecord.ExamManage/resView';
// 详情
export const examManageInfoApi = baseUrl + '/erecord.ExamManage/getInfo';
// 科目配置-列表
export const examManageConfigListApi = baseUrl + '/erecord.ExamManage/getConfigList';
// 科目配置-详情
export const examManageConfigInfoApi = baseUrl + '/erecord.ExamManage/getConfigInfo';
// 科目配置-新增
export const examManageConfigAddApi = baseUrl + '/erecord.ExamManage/actConfigAdd';
// 科目配置-编辑
export const examManageConfigEditApi = baseUrl + '/erecord.ExamManage/actConfigEdit';
// 科目配置-删除
export const examManageConfigDeleteApi = baseUrl + '/erecord.ExamManage/actConfigDelete';
// 公布等次-列表
export const examManageLevelListApi = baseUrl + '/erecord.ExamManage/getLevelList';
// 公布等次-详情
export const examManageLevelInfoApi = baseUrl + '/erecord.ExamManage/getLevelInfo';
// 公布等次-新增
export const examManageLevelAddApi = baseUrl + '/erecord.ExamManage/actLevelAdd';
// 公布等次-编辑
export const examManageLevelEditApi = baseUrl + '/erecord.ExamManage/actLevelEdit';
// 公布等次-删除
export const examManageLevelDeleteApi = baseUrl + '/erecord.ExamManage/actLevelDelete';
// 年级科目-列表
export const examManageSubjectListApi = baseUrl + '/erecord.ExamManage/getSubjectList';
// 年级科目-详情
export const examManageSubjectInfoApi = baseUrl + '/erecord.ExamManage/getSubjectInfo';
// 年级科目-新增
export const examManageSubjectAddApi = baseUrl + '/erecord.ExamManage/actSubjectAdd';
// 年级科目-编辑
export const examManageSubjectEditApi = baseUrl + '/erecord.ExamManage/actSubjectEdit';
// 年级科目-删除
export const examManageSubjectDeleteApi = baseUrl + '/erecord.ExamManage/actSubjectDelete';

// 考试成绩-班主任-新
// 列表
export const examTeacherListApi = baseUrl + '/erecord.ExamTeacher/getList';
// 资源
export const examTeacherViewApi = baseUrl + '/erecord.ExamTeacher/resView';
// 详情
export const examTeacherInfoApi = baseUrl + '/erecord.ExamTeacher/getInfo';
// 新增
export const examTeacherAddApi = baseUrl + '/erecord.ExamTeacher/actAdd';
// 发布
export const examTeacherStateApi = baseUrl + '/erecord.ExamTeacher/setState';
// 删除
export const examTeacherDeleteApi = baseUrl + '/erecord.ExamTeacher/actDelete';
// 下载模板
export const examTeacherdownloadApi = baseUrl + '/erecord.ExamTeacher/download';
// 导入预览
export const examTeacherImportApi = baseUrl + '/erecord.ExamTeacher/import';
// 成绩保存
export const examTeacherSaveScoreApi = baseUrl + '/erecord.ExamTeacher/actSaveScore';

// 布置作业
// 列表
const getAssignmentListApi = baseUrl + '/serve.Homework/getList';
// 资源
const editAssignmentApi = baseUrl + '/serve.Homework/resView';
// 新增提交
const addAssignmentApi = baseUrl + '/serve.Homework/actAdd';
// 编辑
const EditHomeWorkApi = baseUrl + '/serve.Homework/getDetail';
// 作业详情
const workDetailsApi = baseUrl + '/serve.Homework/getInfo';

// 学生请假
// 列表
export const studentLeaveWeekList = baseUrl + '/classlog.ClassLog/getWeekClassLogAttendanceList';
// 列表--周汇总
export const studentLeaveWeekListApi = baseUrl + '/classlog.ClassLog/getWeekClassLogAttendanceList';
// 列表--月汇总
export const studentLeaveMonthListApi = baseUrl + '/classlog.ClassLog/getMonthClassLogAttendanceList';
// 周汇总详情
export const studentLeaveWeekDetailApi = baseUrl + '/classlog.ClassLog/getWeekDetail';
// 周汇总导出
export const studentLeaveExportWeekApi = baseUrl + '/classlog.ClassLog/exportWeekDetail';
// 月汇总详情
export const studentLeaveMonthDetailApi = baseUrl + '/classlog.ClassLog/getMonthDetail';
// 月汇总导出
export const studentLeaveExportMonthApi = baseUrl + '/classlog.ClassLog/exportMonthDetail'
// 单日请假详情
export const studentLeaveDateAttendanceDetailApi = baseUrl + '/classlog.ClassLog/getDateAttendanceDetail';
// 资源
export const studentLeaveViewApi = baseUrl + '/classlog.ClassLog/resView';

// 教师请假
// 列表--周汇总
export const teacherLeaveWeekListApi = baseUrl + '/teacherchecking.TeacherAttendance/getWeekTeacherAttendanceList';
// 列表--月汇总
export const teacherLeaveMonthListApi = baseUrl + '/teacherchecking.TeacherAttendance/getMonthTeacherAttendanceList';
// 周汇总详情
export const teacherLeaveWeekDetailApi = baseUrl + '/teacherchecking.TeacherAttendance/getWeekDetail';
// 周汇总导出
export const teacherLeaveExportWeekApi = baseUrl + '/teacherchecking.TeacherAttendance/exportWeekDetail';
// 月汇总详情
export const teacherLeaveMonthDetailApi = baseUrl + '/teacherchecking.TeacherAttendance/getMonthDetail';
// 月汇总导出
export const teacherLeaveExportMonthApi = baseUrl + '/teacherchecking.TeacherAttendance/exportMonthDetail'
// 单日请假详情
export const teacherLeaveDateAttendanceDetailApi = baseUrl + '/teacherchecking.TeacherAttendance/getDateAttendanceDetail';
// 资源
export const teacherLeaveViewApi = baseUrl + '/teacherchecking.TeacherAttendance/resView';
// 配置审核人
export const teacherLeaveAddCheckerApi = baseUrl + '/teacherchecking.TeacherAttendance/addChecker';
// 配置列表
export const teacherLeaveCheckerListApi = baseUrl + '/teacherchecking.TeacherAttendance/leaveList';


// 服务学生
// 列表
const getServeStudentListApi = baseUrl + '/serve.ServeStudent/getList';
// 资源
const serveStudentRessViewApi = baseUrl + '/serve.ServeStudent/resView';
// 详细
const getDetailApi = baseUrl + '/serve.ServeStudent/getdetail';
// 详情
const getInfoApi = baseUrl + '/serve.ServeStudent/getInfo';
// 导出全部
const exportAllApi = baseUrl + '/serve.ServeStudent/exportDate';
// 导出单个
const exportOneApi = baseUrl + '/serve.ServeStudent/export';
// 新增
const addServeStudentApi = baseUrl + '/serve.ServeStudent/actAdd';


// 陪餐台账
// 列表
const dinnerListApi = baseUrl + '/serve.MealBook/getList';
// 详细
const dinnerInfoApi = baseUrl + '/serve.MealBook/getInfo';
// 详情
const dinnerDetailApi = baseUrl + '/serve.MealBook/getDetail';
// 资源
const dinnerResViewApi = baseUrl + '/serve.MealBook/resView';
// 新增
const dinnerAddApi = baseUrl + '/serve.MealBook/actAdd';
// 编辑
const dinnerEditApi = baseUrl + '/serve.MealBook/actEdit';
// 导出
const dinnerExportApi = baseUrl + '/serve.MealBook/export';

// 每周菜单
// 列表
const WeekDishListApi = baseUrl + '/serve.WeekDish/getList';
// 资源
const WeekDishresViewApi = baseUrl + '/serve.WeekDish/resView';
// 详细
const WeekDishInfoApi = baseUrl + '/serve.WeekDish/getInfo';
// 周数-详细
const WeekDishDetailApi = baseUrl + '/serve.WeekDish/getDetail';
// 导入
const WeekDishImportApi = baseUrl + '/serve.WeekDish/import';
// 提交
const WeekDishAddApi = baseUrl + '/serve.WeekDish/actAdd';
// 导出
const WeekDishExportApi = baseUrl + '/serve.WeekDish/export';

//工作计划
//列表
const workPlanList = baseUrl + '/summary.WorkPlan/getList';
//导出
const workPlanExport = baseUrl + '/summary.WorkPlan/exportDate';
//表格导出
const workPlanTableExport = baseUrl + '/summary.WorkPlan/export';
//计划详情
const workPlanDetail = baseUrl + '/summary.WorkPlan/getDetail';
//资源
const workPlanView = baseUrl + '/summary.WorkPlan/resView';
//新增
const workPlanAdd = baseUrl + '/summary.WorkPlan/actAdd';
//详情
const workPlanInfo = baseUrl + '/summary.WorkPlan/getInfo';

//工作总结
export const workSummaryListApi = baseUrl + '/summary.WorkSummary/getList'
//工作总结导出 按日期
export const workSummaryDateExportApi = baseUrl + '/summary.WorkSummary/exportDate'
//工作总结导出 按周数
export const workSummaryExportApi = baseUrl + '/summary.WorkSummary/export'
//获取部门及周数
export const workSummaryViewApi = baseUrl + '/summary.WorkSummary/resView'
//获取工作总结新增
export const workSummaryAddApi = baseUrl + '/summary.WorkSummary/actAdd'
//获取工作总结详情
export const workSummaryDetailApi = baseUrl + '/summary.WorkSummary/getDetail'
//获取工作总结编辑
export const workSummaryEditApi = baseUrl + '/summary.WorkSummary/actEdit'

//班务日志列表
export const classLogListApi = baseUrl + '/classlog.ClassLog/getList'
//班级列表 统计 周数
export const classListApi = baseUrl + '/classlog.ClassLog/resView'
//班务日志导出 按日期
export const classLogDateExportApi = baseUrl + '/classlog.ClassLog/exportDate'
//班务日志导出 按时间
export const classLogExportApi = baseUrl + '/classlog.ClassLog/export'
//班务日志新增编辑
export const classLogAddApi = baseUrl + '/classlog.ClassLog/actAdd'
//班务日志新增编辑详情
export const classLogDetailApi = baseUrl + '/classlog.ClassLog/getDetail'
//班务日志详情
export const classLogInfoApi = baseUrl + '/classlog.ClassLog/getInfo'
//班务日志统计
export const classLogStaticsApi = baseUrl + '/classlog.ClassLog/getStatistic'
//班级考勤详情
export const classLogAttendanceInfoApi = baseUrl + '/classlog.ClassLog/getAttendanceInfo'
//班务日志 配置列表
export const classLogConfigListApi = baseUrl + '/classlog.ClassLog/getConfigList'
//班务日志 配置详情
export const classLogConfigInfoApi = baseUrl + '/classlog.ClassLog/getConfigInfo'
//班务日志 配置新增
export const classLogConfigAddApi = baseUrl + '/classlog.ClassLog/actConfigAdd'
//班务日志 配置编辑（配置按钮）
export const classLogConfigEditApi = baseUrl + '/classlog.ClassLog/actConfigEdit'
//班务日志 配置删除
export const classLogConfigDeleteApi = baseUrl + '/classlog.ClassLog/actConfigDelete'
//班务日志 情况说明
export const classLogExplainInfoApi = baseUrl + '/classlog.ClassLog/getExplainInfo'
//班务日志 情况说明-保存
export const classLogExplainSaveApi = baseUrl + '/classlog.ClassLog/actConfigExplain'


//教师考勤导出 按日期
export const teacherWorkDateExportApi = baseUrl + '/teacherchecking.TeacherAttendance/exportDate'
//教师考勤导出
export const teacherWorkExportApi = baseUrl + '/teacherchecking.TeacherAttendance/export'
//教师列表
export const teacherWorkListApi = baseUrl + '/teacherchecking.TeacherAttendance/getList'
//教师考勤详情
export const teacherWorkDetailApi = baseUrl + '/teacherchecking.TeacherAttendance/getInfo'
//教师考勤资源
export const teacherWorkView = baseUrl + '/teacherchecking.TeacherAttendance/resView'
//教师考勤新增
export const teacherWorkAdd = baseUrl + '/teacherchecking.TeacherAttendance/actAdd'
//教师考勤编辑
export const teacherWorkEdit = baseUrl + '/teacherchecking.TeacherAttendance/actEdit'

//校务信息
export const generalLogListApi = baseUrl + '/schooloffice.GeneralLog/getList'
//校务信息导出 按日期
export const generalLogDateExportApi = baseUrl + '/schooloffice.GeneralLog/exportDate'
//校务信息导出 按项
export const generalLogExportApi = baseUrl + '/schooloffice.GeneralLog/export'
//获取新增初始数据
export const generalLogWeekApi = baseUrl + '/schooloffice.GeneralLog/resView'
//校务信息新增
export const generalLogAddApi = baseUrl + '/schooloffice.GeneralLog/actAdd'
//获取校务信息详情
export const generalLogDetailApi = baseUrl + '/schooloffice.GeneralLog/getInfo'
//获取校务信息编辑
export const generalLogEditApi = baseUrl + '/schooloffice.GeneralLog/actEdit'
//学校小队长列表
export const headMasterListApi = baseUrl + '/schooloffice.GeneralLog/getHeadermaster'
//评分项-列表
export const generalLogConfigListApi = baseUrl + '/schooloffice.GeneralConfig/getList'
//评分项-保存
export const generalLogConfigSaveApi = baseUrl + '/schooloffice.GeneralConfig/actSave'


//德育常规导出 按日期
export const moralDateExportApi = baseUrl + '/schooloffice.MoralCulture/exportDate'  //原schooloffice.GeneralLog/exportWeekDate
//德育常规导出
export const moralExportApi = baseUrl + '/schooloffice.MoralCulture/export'  //原schooloffice.GeneralLog/exportWeek
//教师列表
export const moralListApi = baseUrl + '/schooloffice.MoralCulture/getList'  //原schooloffice.GeneralLog/weekList
//德育常规详情
export const moralDetailApi = baseUrl + '/schooloffice.MoralCulture/getInfo'  //原schooloffice.GeneralLog/weekInfo
//加分项详情
export const moralAddDetailApi = baseUrl + '/schooloffice.MoralCulture/getBonusInfo'
//加分项保存
export const moralAddSaveApi = baseUrl + '/schooloffice.MoralCulture/actBonusSave'

// 校务服务
// 刷卡出校
// 获取列表
export const getSchoolInfoApi = baseUrl + '/schoolover.SwipeCardLog/getList'
// 详情
export const getSchoolDetailApi = baseUrl + '/schoolover.SwipeCardLog/getInfo'
// 导出
export const schoolExportOneApi = baseUrl + '/schoolover.SwipeCardLog/export'


export const departmentManagementDelApi = baseUrl + '/basic.Department/actDelete'

export const departmentManagementInfoApi = baseUrl + '/basic.Department/getInfo'

export const departmentManagementAddpi = baseUrl + '/basic.Department/actAdd'

export const departmentManagementEditApi = baseUrl + '/basic.Department/actEdit'

// 管理人员
export const managementPersonnelListApi = baseUrl + '/basic.Manage/getList'
// 详细
export const getManageResViewApi = baseUrl + '/basic.Manage/resView'
// 获取管理权限
export const getManageRoleListApi = baseUrl + '/basic.Manage/getManageRoleList'
// 新增
export const addManagementPersonnelApi = baseUrl + '/basic.Manage/actAdd'
// 删除
export const removeAdministratorApi = baseUrl + '/basic.manage/actDelete'
// 详情
export const getManageInfoApi = baseUrl + '/basic.Manage/getInfo'
// 获取当前账号所有的权限
export const getManageNodesListApi = baseUrl + '/basic.Manage/getManageNodesList'
// 编辑
export const editAdministratorApi = baseUrl + '/basic.Manage/actEdit'

// 校园活动
// 获取列表
export const getActivityListApi = baseUrl + '/schoolactivity.SchoolActivity/getList'
// 新增
export const getActivityAddApi = baseUrl + '/schoolactivity.SchoolActivity/actAdd'
// 修改
export const getActivityEditApi = baseUrl + '/schoolactivity.SchoolActivity/actEdit'
// 详情
export const getActivityInfoApi = baseUrl + '/schoolactivity.SchoolActivity/getInfo'
// 发布
export const getActivityPublishApi = baseUrl + '/schoolactivity.SchoolActivity/actPublish'
// 删除
export const getActivityDeleteApi = baseUrl + '/schoolactivity.SchoolActivity/actDelete'


// 内容审核
// 通知审核
// 列表
export const getNoticeListApi = baseUrl + '/notice.NoticeVerify/getList'
// 批量审核 (通知)
export const batchReviewApi = baseUrl + '/notice.NoticeVerify/actVerify'
// 批量审核 (课表)
export const batchTimetableReviewApi = baseUrl + '/timetable.TimetableVerify/actVerify'
// 批量审核 (活动)
export const batchActivityReviewApi = baseUrl + '/schoolactivity.ActivityVerify/actVerify'
// 获取协议类型
export const getProtocolApi = baseUrl + '/notice.NoticeVerify/getProtocol'
// 获取课表
export const getClassResViewApi = baseUrl + '/timetable.TimetableVerify/resView'

// 单条审核
export const individualReviewApi = baseUrl + '/notice.NoticeVerify/actSingleVerify'
// 班级课表审核页面-查看详情
export const classTimetableVerifyApi = baseUrl + '/timetable.TimetableVerify/actSingleVerify'
// 校园活动审核页面-查看详情
export const schoolActivityVerifyApi = baseUrl + '/schoolactivity.ActivityVerify/actSingleVerify'


// 详情
export const viewDetailsApi = baseUrl + '/notice.NoticeVerify/getInfo'
// 班级课表审核页面-查看详情
export const classTimetableInfoApi = baseUrl + '/timetable.TimetableVerify/getInfo'
// 校园活动审核页面-查看详情
export const schoolActivityInfoApi = baseUrl + '/schoolactivity.ActivityVerify/getInfo'



// 班务审核
// 列表
export const getCrewMemberListApi = baseUrl + '/classlog.ClassAudit/getList'
// 批量审核
export const batchAuditApi = baseUrl + '/classlog.ClassAudit/actBatchAudit'
// 详情
export const shiftDetailsApi = baseUrl + '/classlog.ClassAudit/getInfo'
// 审核
export const actAuditApi = baseUrl + '/classlog.ClassAudit/actAudit'
// 保存
export const actAddApi = baseUrl + '/classlog.ClassAudit/actAdd'

//布置作业
//列表--教师、领导
export const homeworkListApi = baseUrl + '/serve.Homeworks/list'
//列表--领导审核
export const homeworkCheckListApi = baseUrl + '/serve.Homeworks/checklist';
//详细
export const homeworkInfoApi = baseUrl + '/serve.Homeworks/info'
//审核
export const homeworkCheckApi = baseUrl + '/serve.Homeworks/check'
//资源
export const homeworkViewApi = baseUrl + '/serve.Homeworks/resView'
//发布
export const homeworkPublishApi = baseUrl + '/serve.Homeworks/publish'
//批量审核
export const homeworkBatchCheckApi = baseUrl + '/serve.Homeworks/batchCheck'
//编辑
export const homeworkEditApi = baseUrl + '/serve.Homeworks/edit'
//添加
export const homeworkAddApi = baseUrl + '/serve.Homeworks/add'
//删除
export const homeworkDeleteApi = baseUrl + '/serve.Homeworks/delete'

//语音预警
//列表
export const bullyWarningListApi = baseUrl + '/voicewarn.BullyWarning/getList'
//详情
export const bullyWarningInfoApi = baseUrl + '/voicewarn.BullyWarning/getInfo'

// 入学年份
export const entryYearsApi = baseUrl + '/index/getEntryYears'

// 人员管理-教师管理
// 学科成绩统计-主页
// 资源
export const subjectScoreViewApi = baseUrl + '/teacher.grades/resView'
// 获取列表
export const subjectScoreListApi = baseUrl + '/teacher.grades/list'
// 新增
export const subjectScoreAddApi = baseUrl + '/teacher.grades/add'
// 修改
export const subjectScoreEditApi = baseUrl + '/teacher.grades/edit'
// 详情
export const subjectScoreInfoApi = baseUrl + '/teacher.grades/info'
// 删除
export const subjectScoreDeleteApi = baseUrl + '/teacher.grades/delete'

// 学科成绩统计-详细
// 资源
export const subjectDetailViewApi = baseUrl + '/teacher.gradesDetail/resView'
// 获取列表
export const subjectDetailListApi = baseUrl + '/teacher.gradesDetail/list'
// 新增
export const subjectDetailAddApi = baseUrl + '/teacher.gradesDetail/add'
// 修改
export const subjectDetailEditApi = baseUrl + '/teacher.gradesDetail/edit'
// 详情
export const subjectDetailInfoApi = baseUrl + '/teacher.gradesDetail/info'
// 删除
export const subjectDetailDeleteApi = baseUrl + '/teacher.gradesDetail/delete'
// 导入
export const subjectDetailImportApi = baseUrl + '/teacher.gradesDetail/import'

// 绩效奖励统计--主页
// 资源
export const rewardViewApi = baseUrl + '/teacher.reward/resView'
// 获取列表
export const rewardListApi = baseUrl + '/teacher.reward/list'
// 新增
export const rewardAddApi = baseUrl + '/teacher.reward/add'
// 修改
export const rewardEditApi = baseUrl + '/teacher.reward/edit'
// 详情
export const rewardInfoApi = baseUrl + '/teacher.reward/info'
// 删除
export const rewardDeleteApi = baseUrl + '/teacher.reward/delete'

// 绩效奖励统计-详细
// 资源
export const rewardDetailViewApi = baseUrl + '/teacher.rewardDetail/resView'
// 获取列表
export const rewardDetailListApi = baseUrl + '/teacher.rewardDetail/list'
// 新增
export const rewardDetailAddApi = baseUrl + '/teacher.rewardDetail/add'
// 修改
export const rewardDetailEditApi = baseUrl + '/teacher.rewardDetail/edit'
// 详情
export const rewardDetailInfoApi = baseUrl + '/teacher.rewardDetail/info'
// 删除
export const rewardDetailDeleteApi = baseUrl + '/teacher.rewardDetail/delete'
// 导入
export const rewardDetailImportpi = baseUrl + '/teacher.rewardDetail/import'

// 教师管理-教师信息
// 列表
export const getTeacherListApi = baseUrl + '/teacher.TeacherPortrait/getList'
// 资源
export const getResViewApi = baseUrl + '/teacher.TeacherPortrait/resView'
// 提交
export const addTeacherListApi = baseUrl + '/teacher.TeacherPortrait/actAdd'
// 删除
export const deleteTeacherListApi = baseUrl + '/teacher.TeacherPortrait/actDelete'
// 详情
export const getTeacherListInfoApi = baseUrl + '/teacher.TeacherPortrait/getInfo'
// 编辑
export const editTeacherListApi = baseUrl + '/teacher.TeacherPortrait/actEdit'
// 雷达图
export const editTeacherRadarInfoApi = baseUrl + '/teacher.TeacherPortrait/getRadarInfo'
// 自动获取信息
export const getTeacherLOtherApi = baseUrl + '/teacher.TeacherPortrait/getOther'
// 导入
export const importTeacherListApi = baseUrl + '/teacher.TeacherPortrait/import'
// 导入结果
export const getTeacherListImportError = baseUrl + '/teacher.TeacherPortrait/getImportError'
// 奖励性绩效
export const editTeacherGradeInfoApi = baseUrl + '/teacher.TeacherPortrait/getGradeInfo'

//学科管理
//列表
const disciplineManagementList = baseUrl + '/basic.SchoolSubject/getList'
//资源
const disciplineManagementView = baseUrl + '/basic.SchoolSubject/resView'
//详情
const disciplineManagementInfo = baseUrl + '/basic.SchoolSubject/getInfo'
//新增
const disciplineManagementAdd = baseUrl + '/basic.SchoolSubject/actAdd'
//编辑
const disciplineManagementEdit = baseUrl + '/basic.SchoolSubject/actEdit'
//删除
const disciplineManagementDel = baseUrl + '/basic.SchoolSubject/actDelete'
//状态
const disciplineManagementState = baseUrl + '/basic.SchoolSubject/setState'

// 校级公告列表
const getSchoolLevelReviewList = baseUrl + '/notice.NoticeVerify/getList'
// 班级公告列表
const getClassReviewList = baseUrl + '/notice.NoticeVerify/getList'
// 校园活动列表
const getActivityReviewList = baseUrl + '/schoolactivity.ActivityVerify/getList'
// 班级课表列表
const getCurriculumReview = baseUrl + '/timetable.TimetableVerify/getList'

// 二维码管理--列表
export const qrCodeListApi = baseUrl + '/schooloffice.Qrcode/getList'
// 新增
export const qrCodeAddApi = baseUrl + '/schooloffice.Qrcode/actAdd'
// 编辑
export const qrCodeEditApi = baseUrl + '/schooloffice.Qrcode/actEdit'
// 删除
export const qrCodeDeleteApi = baseUrl + '/schooloffice.Qrcode/actDel'
// 查看详情
export const qrCodeInfoApi = baseUrl + '/schooloffice.Qrcode/getInfo'
// 创建二维码
export const qrCodeCreateQrApi = baseUrl + '/schooloffice.Qrcode/createQr'

//评课议课
//列表
const evaluateDiscussList = baseUrl + '/listen.ListenActivity/getList'
//详情
const evaluateDiscussInfo = baseUrl + '/listen.ListenActivity/getInfo'
//详情查看
const evaluateDiscussDetail = baseUrl + '/listen.ListenActivity/getDetail'
//资源
const evaluateDiscussView = baseUrl + '/listen.ListenActivity/resView'
//新增
const evaluateDiscussAdd = baseUrl + '/listen.ListenActivity/actAdd'
//获取教师信息
const evaluateDiscussTeacher = baseUrl + '/listen.ListenActivity/getTeacher'
//编辑
const evaluateDiscussEdit = baseUrl + '/listen.ListenActivity/actEdit'
//删除
const evaluateDiscussDel = baseUrl + '/listen.ListenActivity/actDelete'
//列表
const evaluateDiscussExport = baseUrl + '/listen.ListenActivity/export'

//听评课标准
//列表
const listenEvaluationCriteriaList = baseUrl + '/listen.ListenCriterion/getList'
//详情
const listenEvaluationCriteriaInfo = baseUrl + '/listen.ListenCriterion/getInfo'
//资源
const listenEvaluationCriteriaView = baseUrl + '/listen.ListenCriterion/resView'
//新增
const listenEvaluationCriteriaAdd = baseUrl + '/listen.ListenCriterion/actAdd'
//编辑
const listenEvaluationCriteriaEdit = baseUrl + '/listen.ListenCriterion/actEdit'
//删除
const listenEvaluationCriteriaDel = baseUrl + '/listen.ListenCriterion/actDelete'


// 系统管理员-首页
export const systemAdminHomeApi = baseUrl + '/safe.Home/sysIndex'
// 教联体-首页
export const unionHomeApi = baseUrl + '/safe.Home/uniIndex'
// 教联体-首页资源
export const uniResViewApi = baseUrl + '/safe.Home/uniResView'


// 人员管理-家长使用日志
export const usageLogsListApi = baseUrl + '/basic.userLoginLog/getList'

// 学生生日祝福-详情
export const happyBirthdayInfoApi = baseUrl + '/conf.BirthdayWish/getInfo'
// 学生生日祝福-提交
export const happyBirthdayEditApi = baseUrl + '/conf.BirthdayWish/edit'

// 楼道大屏管理
// 列表
export const screenManageListApi = baseUrl + '/work.ScreenShow/getScreenShowList'
// 编辑
export const screenManageEditApi = baseUrl + '/work.ScreenShow/actEdit'

// 工作报表统计-列表
export const workReportListApi = baseUrl + '/work.WorkReport/getList'
// 详情
export const workReportDetailApi = baseUrl + '/work.WorkReport/getDetail'
// 导出
export const workReportExportApi = baseUrl + '/work.WorkReport/export'

// 生成统计报表
export const testApi1 = baseUrl + '/work.WorkReport/createWorkReport'
// 生成周打卡
export const testApi2 = baseUrl + '/work.WorkReport/createDutyWeekCount'
// 生成周班务日志
export const testApi3 = baseUrl + '/work.WorkReport/createClassWeekCount'
// 生成周放学刷卡
export const testApi4 = baseUrl + '/work.WorkReport/createLeaveCount'
// 生成周预警处理
export const testApi5 = baseUrl + '/work.WorkReport/createSafeWeekWarning'

// 教师信息档案-列表
export const teacherArchivesListApi = baseUrl + '/teacher.TeacherProfile/getList'
// 详情
export const teacherArchivesInfoApi = baseUrl + '/teacher.TeacherProfile/getInfo'
// 列表
export const teacherArchivesLogListApi = baseUrl + '/teacher.TeacherProfile/getLogList'
// 详情
export const teacherArchivesLogInfoApi = baseUrl + '/teacher.TeacherProfile/getLogInfo'
// 导出
export const teacherArchivesExportApi = baseUrl + '/teacher.TeacherProfile/export'
// 导出历史记录
export const teacherArchivesExportLogApi = baseUrl + '/teacher.TeacherProfile/exportLog'
// 资源
export const teacherArchivesViewApi = baseUrl + '/teacher.TeacherProfile/resView'

// 分组通知
// 通知列表
export const groupNoticeListApi = baseUrl + '/notice.Notice/getNoticeList'
// 通知列表资源
export const groupNoticeResViewApi = baseUrl + '/notice.Notice/getResView'
// 查看通知
export const groupNoticeInfoApi = baseUrl + '/notice.Notice/getNoticeInfo'
// 分组列表
export const groupSettingListApi = baseUrl + '/notice.NoticeGroup/getList'
// 教师列表
export const groupSettingTeacherListApi = baseUrl + '/notice.NoticeGroup/resView'
// 资源
export const groupSettingViewApi = baseUrl + '/school.Manage/resView'
// 分组新增
export const groupSettingAddApi = baseUrl + '/notice.NoticeGroup/actAdd'
// 分组修改
export const groupSettingEditApi = baseUrl + '/notice.NoticeGroup/actEdit'
// 分组详情
export const groupSettingInfoApi = baseUrl + '/notice.NoticeGroup/getInfo'
// 分组删除
export const groupSettingDeleteApi = baseUrl + '/notice.NoticeGroup/actDelete'
// 查阅详情
export const groupConfirmListApi = baseUrl + '/notice.NoticeConfirm/getList'

// 教学巡查整改-旧
// 列表
export const dailyRectifyListApi = baseUrl + '/schooloffice.DailyRectify/getList'
// 详情
export const dailyRectifyInfoApi = baseUrl + '/schooloffice.DailyRectify/getInfo'
// 详情中查看
export const dailyRectifyDetailApi = baseUrl + '/schooloffice.DailyRectify/getDetail'
// 导出
export const dailyRectifyExportApi = baseUrl + '/schooloffice.DailyRectify/export'
// 导出多日
export const dailyRectifyExportDateApi = baseUrl + '/schooloffice.DailyRectify/exportDate'

// 教学巡查整改-新
// 列表
export const teachRectifyListApi = baseUrl + '/schooloffice.TeachRectify/getList'
// 详情
export const teachRectifyInfoApi = baseUrl + '/schooloffice.TeachRectify/getInfo'
// 详情-查看
export const teachRectifyDetailApi = baseUrl + '/schooloffice.TeachRectify/getDetail'
// 导出-单日
export const teachRectifyExportApi = baseUrl + '/schooloffice.TeachRectify/export'
// 导出多日
export const teachRectifyExportDateApi = baseUrl + '/schooloffice.TeachRectify/exportDate'

export {
    resetPassword,
    uploadApi,
    uploadApis,
    uploadFile,
    uploadLargeFile,
    regVerifyApi,
    getVerifyApi,
    hashApi,
    nodesApi,
    loginApi, //学校列表
    codeApi, // 登录
    logOutApi, //登出
    msmxSsoUrlApi,
    modifyPasswordApi,
    loginLogList,
    operateLogList,
    resArrayList,
    operateLogsList,
    resArraysList,
    dataListApi,
    regionApi, //区县
    switchUserRolesApi,
    homeInfoApi,
    homeListApi,
    dashboardApi,

    //系统管理员接口
    adminListApi,
    adminAddApi,
    adminEditApi,
    adminDelApi,
    adminViewApi,
    adminInfoApi,

    //市级账号接口
    cityManageListApi,
    cityManageAddApi,
    cityManageEditApi,
    cityManageDeleteApi,
    cityManageViewApi,
    cityManageInfoApi,
    cityManageSetApi,

    //区级账号接口
    areaManageListApi,
    areaManageActAddApi,
    areaManageActEditApi,
    areaManageActDelApi,
    areaManageViewApi,
    areaManageInfoApi,
    areaManageSetApi,


    // 学校账号接口
    schoolManageListApi,
    schoolManageAddApi,
    schoolManageEditApi,
    schoolManageDeleteApi,
    schoolManageViewApi,
    schoolManageErrApi,
    schoolManageInfoApi,
    schoolManageQueryApi,
    schoolManageImportApi,
    schoolManageSetApi,

    //管理员接口
    platManageListApi,
    platManageAddApi,
    platManageEditApi,
    platManageDeleteApi,
    platManageInfoApi,
    platManageViewApi,
    platManageSetApi,

    //学校管理员接口
    schoolPlatManageListApi,
    schoolPlatManageAddApi,
    schoolPlatManageEditApi,
    schoolPlatManageDeleteApi,
    schoolPlatManageInfoApi,
    schoolPlatManageViewApi,
    schoolPlatManageSetApi,
    schoolUpdataApi,

    //学校管理接口
    schoolListApi,
    schoolAddApi,
    schoolEditApi,
    schoolInfoApi,
    schoolDelApi,
    schoolNodeApi,
    getSchoolApi,
    schoolDisplayApi,
    schoolDirectlyApi,
    schoolSortApi,
    schoolViewApi,
    schoolSetApi,
    schoolInfosApi,
    schoolInfoActEdit,

    //学校信息接口
    basicSchoolApi,

    //用户列表
    userListApi,
    regionListApi,
    unbindUserApi,
    userViewApi,
    userListDelApi,
    drillStaEnd,


    //系统设置
    configurationManagementListApi,
    configurationManagementAddApi,
    configurationManagementEditApi,
    configurationManagementDelApi,
    cacheListApi,
    refreshCacheApi,
    refreshCacheQbApi,
    roleManagementListApi,
    roleManagementAddApi,
    roleManagementEditApi,
    roleManagementRolesApi,
    roleManagementDelApi,
    roleManagementRangeListApi,
    roleManagementRangeActBatchNodes,
    roleManagementRangeApi,
    regionalManagementListApi,
    regionalManagementAddApi,
    regionalManagementEditApi,
    regionalManagementDelApi,
    dataDictionaryListApi,
    dataDictionaryZdListApi,
    dataDictionaryZdAddApi,
    dataDictionaryZdEditApi,
    dataDictionaryZdDelApi,
    dataDictionaryZdInfoApi,
    batchComparisonApi,
    batchProcessingApi,
    resourceManagementListgApi,
    resourceManagementAddApi,
    resourceManagementEditApi,
    resourceManagementDelApi,
    resourceManagementInfoApi,
    resourceOrgListgApi,
    resourceOrgAddApi,
    resourceOrgEditApi,
    resourceOrgDelApi,
    roleOrgListApi,
    roleOrgAddApi,
    roleOrgEditApi,
    roleOrgRolesApi,
    roleOrgDelApi,
    roleOrgRangeListApi,

    //多媒体管理
    multimediaList,
    multimediaView,
    multimediaInfo,
    multimediaAdd,
    multimediaEdit,
    multimediaDel,
    multimediaStop,

    //演练管理
    drillListApi,
    drillView,
    viewTaskApi,
    viewTaskDelApi,
    drillManagementAddApi,
    drillManagementEditApi,
    //演练管理-铃声配置
    ringtoneConfigurationGetApi,
    ringtoneConfigurationAddApi,
    ringtoneConfigurationGetInfoApi,
    ringtoneConfigurationGetEdit,
    ringtoneConfigurationDel,
    //演练管理--电子班牌
    deckListApi,
    deckArrangementEditApi,
    deckArrangementAdd,
    deckArrangementInfo,
    deckArrangementDel,
    //屏幕配置
    screenConfigurationList,
    screenConfigurationInfo,
    screenConfigurationAdd,
    screenConfigurationEdit,
    screenConfigurationDel,
    //预警灯配置
    switchMentList,
    switchMentInfo,
    switchMentAdd,
    switchMentEdit,
    switchMentDel,
    //设备管理
    equipmentList,
    equipmentView,
    equipmentTypeList,
    equipmentInfo,
    equipmentAdd,
    equipmentEdit,
    equipmentDel,
    equipmentDisabled,
    getBrandListApi,
    getModelListApi,
    //预警看板
    earlyWarningList,
    earlyWarningInfo,
    earlyWarningView,
    //预警处理
    warningProcessingList,
    warningProcessingInfo,
    warningProcessingHandle,
    warningProcessingDel,
    //素材中心
    materialCenterList,
    materialCenterAdd,
    materialCenterEdit,
    materialCenterDel,
    //设备位置管理
    locationManagementList,
    locationManagementView,
    locationManagementInfo,
    locationManagementAdd,
    locationManagementEdit,
    locationManagementDel,
    //数据看板
    dataBoardDate,
    dataBoardWarn,
    dataBoardAttendance,
    dataBoardVisit,
    dataBoardWeather,
    dataBoardWarnTwo,
    dataBoardAttendanceTwo,
    dataBoardVisitTwo,
    newSubmitInfoApi,
    //临时铃声
    temporaryRingtoneView,
    temporaryRingtoneList,
    temporaryRingtoneInfo,
    temporaryRingtoneAdd,
    temporaryRingtoneEdit,
    temporaryRingtoneDel,
    temporaryRingtoneStatus,
    temporaryRingtoneFileList,
    //演练结果
    drillResultList,
    drillResultView,
    drillResultInfo,
    drillResultTaskInfo,
    //设备开关
    equipmentSwitchList,
    equipmentSwitchView,
    equipmentSwitchAdd,
    equipmentSwitchEdit,
    equipmentSwitchDel,
    equipmentSwitchInfo,
    equipmentSwitchDeviceInfo,
    equipmentSwitchEditDevice,
    equipmentSwitchStatus,
    equipmentSwitchAllOnOff,
    equipmentSwitchTypeList,
    //学生管理
    studentManagementList,
    studentManagementGrades,
    studentManagementClass,
    studentManagementInfo,
    studentManagementAdd,
    studentManagementEdit,
    studentManagementDel,
    studentManagementImport,
    studentManagementExport,
    studentManagementImportError,
    studentManagementGetSex,
    //学生在校表现
    schoolPerformanceList,
    schoolPerformanceArchivesList,
    schoolPerformanceInfo,
    schoolPerformanceView,
    schoolPerformanceAdd,
    schoolPerformanceEdit,
    schoolPerformanceDel,
    //在线档案管理
    archivesManagementList,
    archivesManagementArchivesList,
    archivesManagementArchivesInfo,
    archivesManagementArchivesBasicInfo,
    //缴费管理（班主任）
    payManagementList,
    payManagementInfo,
    payManagementView,
    payManagementStudentList,
    payManagementAdd,
    payManagementEdit,
    payManagementDel,
    //缴费管理（领导）
    paymentSettingList,
    paymentSettingStudentList,
    paymentSettingView,
    //心理咨询管理领导
    mentalHealthViewApi,
    mentalHealthListApi,
    mentalHealthInfoApi,
    //素质报告书
    reportManagementList,
    reportStudentList,
    reportAddView,
    reportAdd,
    reportAddInfo,
    reportEdit,
    reportDelete,
    reportSettingList,
    reportSettingInfo,
    reportSettingDelete,
    //心理咨询
    psychologicalList,
    psychologicalView,
    psychologicalInfo,
    psychologicalReply,
    userInfoApi,
    counselingListApi,
    recordStartTimeApi,
    recordEndTimeApi,
    uploadFileApi,
    counselingTimeOutApi,
    //电子学生证
    studentCardListApi,
    studentCardDetailApi,
    studentCardHandleApi,
    //设备地图
    equipmentMapList,
    equipmentMapInfo,
    equipmentMapHistoryList,
    //通知公告
    noticeSchoolViewApi,
    noticeListApi,
    noticeAddApi,
    noticeEditApi,
    noticeInfoApi,
    noticePublishApi,
    noticeDeleteApi,
    noticeSchoolListApi,
    noticeSchoolAddApi,
    noticeSchoolEditApi,
    noticeSchoolInfoApi,
    noticeSchoolPublishApi,
    noticeSchoolDeleteApi,
    noticeProtocolApi,
    noticeSignListApi,
    noticeConfirmListApi,
    noticeClassSignApi,
    noticeClassConfirmApi,
    noticeExportApi,
    //失物招领
    lostListApi,
    lostInfoApi,
    // 班级课表
    timetableTListApi,
    timetableTAddApi,
    timetableTPublishApi,
    timetableTInfoApi,
    timetableTEditApi,
    timetableTDeleteApi,
    timetableTViewApi,
    timetableSchoolListApi,
    timetableSchoolInfoApi,
    timetableSchoolExportApi,
    // 考试成绩
    examlistApi,
    examViewApi,
    examSchoolListApi,
    examAddApi,
    examStudentsApi,
    examStateApi,
    examInfoApi,
    examDeleteApi,
    examActAddStuApi,
    // 布置作业
    getAssignmentListApi,
    editAssignmentApi,
    addAssignmentApi,
    EditHomeWorkApi,
    workDetailsApi,
    // 服务学生
    getServeStudentListApi,
    serveStudentRessViewApi,
    getDetailApi,
    getInfoApi,
    exportAllApi,
    exportOneApi,
    addServeStudentApi,
    // 陪餐台账
    dinnerListApi,
    dinnerInfoApi,
    dinnerDetailApi,
    dinnerResViewApi,
    dinnerAddApi,
    dinnerEditApi,
    dinnerExportApi,
    //每周菜单
    WeekDishListApi,
    WeekDishresViewApi,
    WeekDishInfoApi,
    WeekDishDetailApi,
    WeekDishImportApi,
    WeekDishAddApi,
    WeekDishExportApi,
    //工作计划
    workPlanList,
    workPlanExport,
    workPlanTableExport,
    workPlanDetail,
    workPlanView,
    workPlanAdd,
    workPlanInfo,
    //学科管理
    disciplineManagementList,
    disciplineManagementView,
    disciplineManagementInfo,
    disciplineManagementAdd,
    disciplineManagementEdit,
    disciplineManagementDel,
    disciplineManagementState,
    // 校级公告审核列表
    getSchoolLevelReviewList,
    // 班级公告审核列表
    getClassReviewList,
    // 校园活动审核列表
    getActivityReviewList,
    // 班级课表列表
    getCurriculumReview,
    //评课议课
    evaluateDiscussList,
    evaluateDiscussInfo,
    evaluateDiscussDetail,
    evaluateDiscussView,
    evaluateDiscussAdd,
    evaluateDiscussTeacher,
    evaluateDiscussEdit,
    evaluateDiscussDel,
    evaluateDiscussExport,
    //听评课标准
    listenEvaluationCriteriaList,
    listenEvaluationCriteriaInfo,
    listenEvaluationCriteriaView,
    listenEvaluationCriteriaAdd,
    listenEvaluationCriteriaEdit,
    listenEvaluationCriteriaDel,
};



// WEBPACK FOOTER //
// ./src/api/index.js